import Api from '../Api.js';
import BaseView from './_BaseView.js';
import Confirm from '../components/Confirm.js';
import Dropdown from '../components/Dropdown.js';
import Table from '../components/Table.js';
import trans from "../util/trans";

export default class RoleMapView extends BaseView {

    init() {
        super.init();

        if ($('#menuPath, #menuGuides, #menuUser').length > 0) {
            this.roleid = $('[data-id]').data('id');
            this.initMenus();
            this.initTables();
        }
    }

    initTables() {
        this.pathTable = new Table('rolepathmaps', `/api/pathway/maptable?roleid=${this.roleid}`, [
            {data: 'select', orderable: false},
            {data: 'order'},
            {data: 'title'},
            {data: 'description'},
            {data: 'guides'},
            {data: 'tools', orderable: false},
        ]);

        this.guideTable = new Table('roleguidemaps', `/api/guides/maptable?roleid=${this.roleid}`, [
            {data: 'select', orderable: false},
            {data: 'order'},
            {data: 'title'},
            {data: 'desc'},
            {data: 'steps'},
            {data: 'tools', orderable: false},
        ]);

        this.userTable = new Table('roleusermaps', `/api/users/maptable?roleid=${this.roleid}`, [
            {data: 'select', orderable: false},
            {data: 'firstname'},
            {data: 'lastname'},
            {data: 'email'},
            {data: 'tools', orderable: false},
        ]);
    }

    initMenus() {
        let self = this;
        this.pathMenu = new Dropdown('#menuPath', {
            onDelete: function (ids) {
                if (ids.length > 0) {
                    Confirm({
                        ok: Lang.remove,
                        title: Lang.pathlinks,
                        msg: trans('unlinkx', ids.length),
                        onConfirm: function () {
                            self.deletePathMap(ids);
                        }
                    });
                }
            }
        });

        this.guideMenu = new Dropdown('#menuGuides', {
            onDelete: function (ids) {
                if (ids.length > 0) {
                    Confirm({
                        ok: Lang.remove,
                        title: Lang.guidelinks,
                        msg: trans('unlinkx', ids.length),
                        onConfirm: function () {
                            self.deleteGuideMaps(ids);
                        }
                    });
                }
            }
        });

        this.userMenu = new Dropdown('#menuUser', {
            onDelete: function (ids) {
                if (ids.length > 0) {
                    Confirm({
                        ok: Lang.remove,
                        title: Lang.removemember,
                        msg: trans('unlinkx', ids.length),
                        onConfirm: function () {
                            self.deleteUserMaps(ids);
                        }
                    });
                }
            }
        });
    }

    deletePathMap(ids) {
        const self = this;
        for (let i = 0, j = ids.length; i < j; i++) {
            Api.send(`/api/role/${this.roleid}/pathway/${ids[i]}`, {}, 'delete').done(function () {
                self.pathTable.reload();
                self.guideTable.reload();
            });
        }
    }

    deleteGuideMaps(ids) {
        const self = this;
        for (let i = 0, j = ids.length; i < j; i++) {
            Api.send(`/api/role/${this.roleid}/guide/${ids[i]}`, {}, 'delete').done(function () {
                self.guideTable.reload();
            });
        }
    }

    deleteUserMaps(ids) {
        const self = this;
        for (let i = 0, j = ids.length; i < j; i++) {
            Api.send(`/api/role/${this.roleid}/user/${ids[i]}`, {}, 'delete').done(function () {
                self.userTable.reload();
            });
        }
    }

    addPathway() {
        const self = this;
        const data = $('form').aeroSerialize();
        data.roleid = this.roleid;
        Api.send('/api/role/addpathway', data, 'post').done(function () {
            self.pathTable.reload();
        });
    }

    addGuide() {
        const self = this;
        const data = $('form').aeroSerialize();
        data.roleid = this.roleid;
        Api.send('/api/role/addguide', data, 'post').done(function () {
            self.guideTable.reload();
        });
    }

    addUser() {
        const self = this;
        const data = $('form').aeroSerialize();
        data.roleid = this.roleid;
        Api.send('/api/role/adduser', data, 'post').done(function () {
            self.userTable.reload();
        });
    }

    pathwayForm() {
        const self = this;
        Api.getTpl('rolepath-form').done(function (r) {
            Api.send('/api/pathway').done(function (p) {
                const tpl = _.template(r);
                Confirm({
                    ok: Lang.save,
                    title: Lang.associaterole,
                    msg: tpl({paths: p}),
                    onConfirm: function () {
                        self.addPathway();
                    }
                });
            });
        });
    }

    guideForm() {
        const self = this;
        Api.getTpl('roleguide-form').done(function (r) {
            Api.send('/api/guides').done(function (guides) {
                const tpl = _.template(r);
                Confirm({
                    ok: Lang.save,
                    title: Lang.associaterole,
                    msg: tpl({guides: guides}),
                    onConfirm: function () {
                        self.addGuide();
                    }
                });
            });
        });
    }

    userForm() {
        const self = this;
        Api.getTpl('roleuser-form').done(function (r) {
            Api.send('/api/users').done(function (users) {
                const tpl = _.template(r);
                Confirm({
                    ok: Lang.save,
                    title: Lang.associaterole,
                    msg: tpl({users: users}),
                    onConfirm: function () {
                        self.addUser();
                    }
                });
            });
        });
    }

    setEvents() {
        const self = this;
        super.setEvents();

        const body = $('body');

        $('#rolepath .add').off("click.pa").on("click.pa", function () {
            self.pathwayForm();
            return false;
        });

        //Delete
        body.off("click.pd").on("click.pd", "#rolepath .delete", function () {
            const id = $(this).parents('div:eq(0)').data('id');
            const name = $(this).parents('tr:eq(0)').find('td:eq(1)').text();

            //Confirm
            Confirm({
                ok: Lang.unlink,
                title: name,
                msg: Lang.unlinkpath,
                onConfirm: function () {
                    self.deletePathMap([id]);
                }
            });
            return false;
        });

        //Add
        $('#rolemap .add').off("click.guia").on("click.guia", function () {
            self.guideForm();
            return false;
        });

        //Delete
        body.off("click.guid").on("click.guid", "#rolemap .delete", function () {
            const id = $(this).parents('div:eq(0)').data('id');
            const name = $(this).parents('tr:eq(0)').find('td:eq(1)').text();

            //Confirm
            Confirm({
                ok: Lang.unlink,
                title: name,
                msg: Lang.unlinkguide,
                onConfirm: function () {
                    self.deleteGuideMaps([id]);
                }
            });
            return false;
        });

        body.on('click', '#rolemap .hide', function () {
            const id = $(this).parents('div:eq(0)').data('id');
            const data = {guideid: id, roleid: self.roleid};
            Api.send(`/api/role/hideguide`, data, 'post').done(function () {
                self.guideTable.reload();
            });
        });

        body.on('click', '#rolemap .unhide', function () {
            const id = $(this).parents('div:eq(0)').data('id');
            const data = {guideid: id, roleid: self.roleid};
            Api.send(`/api/role/unhideguide`, data, 'post').done(function () {
                self.guideTable.reload();
            });
        });

        //Add
        $('#roleusermap .add').off("click.ua").on("click.ua", function () {
            self.userForm();
            return false;
        });

        //Delete
        body.off("click.ud").on("click.ud", "#roleusermap .delete", function () {
            const id = $(this).parents('div:eq(0)').data('id');
            const name = $(this).parents('tr:eq(0)').find('td:eq(1)').text();

            //Confirm
            Confirm({
                ok: Lang.unlink,
                title: name,
                msg: Lang.unlinkuser,
                onConfirm: function () {
                    self.deleteUserMaps([id]);
                }
            });
            return false;
        });

        $('.acl').on('change', function () {
            const $l = $(this).parents('.switch-wrapper');
            const key = $l.data('key');
            const type = $l.data('type');

            const data = {};
            data[key] = {};
            data[key][type] = $(this).is(':checked');

            //Save permission
            Api.send(`/api/role/${self.roleid}/permission`, data, 'patch');
        });
    }

}
